/**
 * A super module that collects available sub-modules.
 *
 * @namespace vef.map.popup
 * @memberof vef.map
 */

export * from './MapPopup.js';
export * from './PopupRenderer.js';
export * from './formattingUtils.js';
export * from './PopupHeader.js';
export * from './PopupPagination.js';

import * as templates from './templates/index.js';
export { templates };

import * as templateFunctions from './templateFunctions/index.js';
export { templateFunctions };

import * as formattingUtils from './formattingUtils.js';
export { formattingUtils };